import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import OptionsFormData from "./OptionsFormData.js";


function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}
const EditOptionsForm = (props) => {
    //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "options";
  const UserInfo = sessionStorage.getItem("User_info")
  ? JSON.parse(sessionStorage.getItem("User_info"))
  : 0;
  const UserName = UserInfo==0?'': UserInfo[0].id;

  const FacilityId = localStorage.getItem("FacilityId");

  const [formData, setFormData] = useState({
    FacilityCode: "",
    FacilityName: "",
    UseFor: "",
    Address: "",
    InvPrepBy: "",
    InvAppBy: "",
    InvSupBy: "",
    StoreTypeId: "",
    SupplyFrom: "",
  });
  const [errorObject, setErrorObject] = useState({});
  //const { id } = useParams();
  const id = FacilityId;
  const queryClient = useQueryClient();

  const { data } = useQuery(
    ["optionsForm", id],
    () =>
      api.getOptionsFormData(id).then((res) => {
        setFormData(res.data);
        return res.data;
        api.dirtyModeDisable();
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { isLoading, mutate } = useMutation(api.updateOptionsForm, {
    onSuccess: (data) => {
      if (data.status == 200) {

        const auth_token = sessionStorage.getItem("token")
        ? sessionStorage.getItem("token")
        : null;
        let options = {};
        options = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth_token}`,
          },
          task:'UOM'
        };


        api.getLoginFacilityListNotEqual99ANDSuppliers(options,'ALL')
        .then((response) => {

          localStorage.setItem(
            "CurrentFacilitySetting",
            JSON.stringify(response.datalist.CurrentFacilitySetting)
          );

        });


        api.getAllDropdown("OptionsFormlist").then((response) => {
          localStorage.setItem(
            "OptionsFormlist",
            JSON.stringify(response.datalist.OptionsFormlist)
          );
        });
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
        queryClient.getQueriesData("optionsForm");
        props.history.push("/options");
        api.dirtyModeDisable();
      }else{

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
       
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;

    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
    api.dirtyModeEnable();
  };

    //====== Start Choosen Dropdown===========
    const handleChangeChoosenProps = (name, value) => {
      let data = { ...formData };
      data[name] = value;   
      setFormData(data); 
      setErrorObject({ ...errorObject, [name]: "" });
      api.dirtyModeEnable();
    }
    //====== End Choosen Dropdown===========

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
    api.dirtyModeEnable();
  };

  const handleReset = () => {
    setFormData({
      FacilityCode: "",
      FacilityName: "",
      UseFor: "",
      Address: "",
      InvPrepBy: "",
      InvAppBy: "",
      InvSupBy: "",
      StoreTypeId: "",
      SupplyFrom: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["FacilityCode","FacilityName"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleUpdate = async (e) => {
    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
      mutate(fDtat);
      //swal("Success!", "", "success");
    }
  };


  return (
    <>
      <OptionsFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleChangeChoosenProps={handleChangeChoosenProps}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        bStockUpdate={props.permissionType}
        {...props}
      />
    </>
  );
};

export default EditOptionsForm;
